import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { useEffect, useState } from "react";
import isEmptyArray from "lodash/isEmpty";
import SvgIcon from "@mui/material/SvgIcon";
import { Sidebar as ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import Logo from "../../assets/common/Logo.svg";
import { Link } from "react-router-dom";
// react-pro-sidebar v1 no longer exposes the old CSS path
// import "react-pro-sidebar/dist/css/styles.css";
// import { styled } from '@mui/material/styles';
import { tokens } from "../../theme";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import {
  collapseMenu,
  isAuthPageAtom,
  openSlidingMenu,
  selectedSidebarTab,
  sessionIdStatus,
} from "../../config/AppConfig";
import { useAtom } from "jotai";
import { BackButtonListener } from "../../components/BackButtonListener";
import {
  CASHOUT_LIMITS_ROUTE,
  CREDIT_DEBIT_ROUTE,
  EARMARK_ROUTE,
  EXCLUSION_ROUTE,
  FINANCE_DASHBOARD,
  FREEZE_ACCOUNT_ROUTE,
  ON_HOLD_ROUTE,
  PAYOUT_DATES_ROUTE,
  PAYOUT_ROUTE,
  REPORTS_FILTER_ROUTE,
  WITHOLDING_TAX_ROUTE,
} from "../../constants/Constant";

/* NEW ICONS */

// import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';

import { useContext } from "react";
import { SidebarContext } from "../../scenes/global/context/sidebarContext.jsx";
import {
  CASHOUT_LIMIT,
  CREDIT_DEBIT,
  DASHBOARD,
  EARMARK,
  EXCLUSION,
  FREEZE_ACCOUNT,
  ON_HOLD,
  PAYOUT,
  PAYOUT_DATES,
  REPORTS,
  WITHOLDING_TAX,
} from "../../constants/Strings.jsx";
import {
  getFromLocalStorage,
  getFromLocalStorageJsonObject,
} from "../../utils/localStorageUtils.js";
import {
  LOGIN_RESPONSE,
  SESSION_ID,
} from "../../constants/LocalStorageKeyValuePairString.jsx";
import DebugLog from "../../utils/DebugLog.jsx";

const Item = ({ title, to, icon, selected, setSelected, visible }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <div>
      {visible && (
        <MenuItem
          active={selected === title}
          component={<Link to={to} />}
          style={{
            color: colors.grey[200],
            // fontFamily: 'Montserrat Bold',
            // fontWeight: "900"
          }}
          onClick={() => setSelected(title)}
          icon={icon}
        >
          <Typography
            sx={{
              fontSize: "0.9rem",
              fontWeight: "500",
            }}
          >
            {title}
          </Typography>
        </MenuItem>
      )}
    </div>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useAtom(collapseMenu);
  //const [isVisible, setIsVisible] = useAtom(false);

  const [selected, setSelected] = useAtom(selectedSidebarTab);
  const [isAuthPage, setAuthStatus] = useAtom(isAuthPageAtom);
  const [slidingMenuStatus, setSlidingMenu] = useAtom(openSlidingMenu);
  const [sessionIdState, setSessionIdState] = useAtom(sessionIdStatus);

  // menu hide / show logic
  const [Validations, setValidations] = useState(false);
  const [Formulas, setFormulas] = useState(false);
  const [Payout, setPayout] = useState(false);
  const [OnHold, setOnHold] = useState(false);
  const [Exclusions, setExclusions] = useState(false);
  const [PayoutDates, setPayoutDates] = useState(false);
  const [WithholdingTax, setWithholdingTax] = useState(false);

  const [adjustmentTitleVisibility, setAjustmentTitleVisibility] =
    useState(false);
  const [incentiveTitleVisibility, setIncentiveTitleVisibility] =
    useState(false);

  const [Earmark, setEarmark] = useState(false);
  const [FreezeAccount, setFreezeAccount] = useState(false);
  const [DebitCredit, setDebitCredit] = useState(false);
  const [cashoutVisible, setCashoutVisible] = useState(false);
  const [reports, setReports] = useState(false);

  // role and acccess sidebar
  const [Cluster, setCluster] = useState(true);
  const [Roles, setRoles] = useState(true);
  const [Hierarchy, setHierarchy] = useState(true);
  const [Modules, setModules] = useState(true);
  const [Users, setUsers] = useState(true);
  const [Request, setRequest] = useState(true);
  const [Log, setLog] = useState(true);

  // reducer and context listening
  const [activeLinkIdx] = useState(3);
  const [sidebarClass, setSidebarClass] = useState("");
  const { isSidebarOpen } = useContext(SidebarContext);

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    // setExpanded(panel);
  };

  useEffect(() => {
    // setIsVisible(openSlidingMenu)
    //setSlidingMenu(openSlidingMenu);
    // setIsCollapsed(openSlidingMenu)

    if (isSidebarOpen) {
      setSidebarClass("sidebar-change");
    } else {
      setSidebarClass("");
    }

    DebugLog(
      "getFromLocalStorage(SESSION_ID)    " + getFromLocalStorage(SESSION_ID),
    );
    const sessionId = getFromLocalStorage(SESSION_ID);
    try {
      if (sessionId !== "") {
        const userDetails = getFromLocalStorageJsonObject(LOGIN_RESPONSE);
        //DebugLog("userDetails from sidebar    " + JSON.stringify(userDetails));

        let incentives = [];
        let adjustments = [];
        let reports = [];
        let cashout = [];

        //const menuArray = userDetails
        //DebugLog("menuList from sidebar    " + JSON.stringify(userDetails));
        if (!isEmptyArray(userDetails)) {
          //DebugLog("userDetails.length  ==== " + userDetails.length);
          let menuListSize = userDetails.length;
          if (menuListSize != null && menuListSize > 0) {
            userDetails.forEach((item, index) => {
              if (item.menuListName === "Incentive") {
                incentives = [...item.menuItem];
              } else if (item.menuListName === "Adjustment") {
                adjustments = [...item.menuItem];
              } else if (item.menuListName === "Reports") {
                reports = [...item.menuItem];
              } else if (item.menuListName === "Cash Out Limit") {
                cashout = [...item.menuItem];
              }
            });

            setPayout(false);
            setOnHold(false);
            setExclusions(false);
            setPayoutDates(false);
            setWithholdingTax(false);
            setEarmark(false);
            setFreezeAccount(false);

            if (incentives.length > 0) {
              setIncentiveTitleVisibility(true);
              incentives.forEach((item, index) => {
                if (item.menuName === "Payout") {
                  setPayout(true);
                } else if (item.menuName === "On Hold") {
                  setOnHold(true);
                } else if (item.menuName === "Exclusions") {
                  setExclusions(true);
                } else if (item.menuName === "Payout Dates") {
                  setPayoutDates(true);
                } else if (item.menuName === "Withholding Tax") {
                  setWithholdingTax(true);
                } else if (item.menuName === "Validations") {
                  setEarmark(true);
                } else if (item.menuName === "Formulas") {
                  setFreezeAccount(true);
                }
              });
            } else {
              setIncentiveTitleVisibility(false);
            }

            setEarmark(false);
            setFreezeAccount(false);
            setDebitCredit(false);
            if (adjustments.length > 0) {
              setAjustmentTitleVisibility(true);
              adjustments.forEach((item, index) => {
                if (item.menuName === "Earmark") {
                  setEarmark(true);
                } else if (item.menuName === "Freeze Account") {
                  setFreezeAccount(true);
                } else if (item.menuName === "Debit/Credit") {
                  setDebitCredit(true);
                }
              });
            } else {
              setAjustmentTitleVisibility(false);
            }

            setReports(false);
            reports.forEach((item, index) => {
              if (item.menuName === "Reports") {
                setReports(true);
              }
            });

            setCashoutVisible(false);
            cashout.forEach((item, index) => {
              if (item.menuName === "Cash Out Limit") {
                setCashoutVisible(true);
              }
            });
          }
        }
      }
    } catch (error) {
      DebugLog(error);
    }
  }, [isSidebarOpen, openSlidingMenu, collapseMenu, sessionIdState]);

  return (
    <Box
      id={"sidebar"}
      sx={{ visibility: { xs: "hidden", sm: "visible !important" } }}
      className={`sidebar ${sidebarClass}`}
    >
      {!isAuthPage ? (
        <Box
          alignItems={"space-between"}
          // visibility={isVisible}
          sx={{
            "& .pro-sidebar": {
              width: "100%",
              minWidth: "auto",
            },
            "& .pro-sidebar.collapsed": {
              width: "20% !important",
              minWidth: "80px",
            },
            "& .pro-sidebar-inner": {
              background: `${colors.white[50]} !important`,
              fontFamily: "Montserrat-Bold",
              height: "100vh",
              borderRadius: "0 24px 24px 0",
            },
            "& .pro-icon-wrapper": {
              backgroundColor: "transparent !important",
            },
            "& .pro-inner-item": {
              padding: "5px 35px 5px 20px !important",
            },
            "& .pro-inner-item:hover, ": {
              color: colors.redAccent[200] + "!important",
              // fontFamily: "Montserrat-Bold",
            },
            "& .pro-menu-item.active": {
              color: colors.redAccent[200] + "!important",
              fontFamily: "Montserrat-Bold",
              fontWeight: "900 !important",
            },
            "& .pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout": {
              justifyContent: "space-around",
            },
            "& .pro-sidebar .pro-sidebar-inner ul li.pro-menu-item": {
              // position: "absolute", top: "1%",
            },
            zIndex: "1000",
          }}
        >
          <BackButtonListener></BackButtonListener>

          <ProSidebar
            collapsed={isCollapsed}
            style={{ height: "100vh" }}
            rootStyles={{ backgroundColor: "#ffffff" }}
          >
            <Menu
              iconShape="square"
              rootStyles={{
                backgroundColor: "#ffffff",
                ["& > ul"]: { backgroundColor: "#ffffff" },
                ["& .ps-menuitem-root"]: { backgroundColor: "#ffffff" },
                ["& .ps-menu-button"]: {
                  backgroundColor: "#ffffff !important",
                },
                ["& .ps-menu-button:hover"]: {
                  backgroundColor: "#f5f5f5 !important",
                },
              }}
            >
              {/* LOGO AND MENU ICON */}

              {/* Menu Toggle */}
              {!isCollapsed && (
                <MenuItem
                  onClick={() => {
                    setIsCollapsed(!isCollapsed);
                  }}
                  style={{ marginBottom: "4px" }}
                >
                  <Box display="flex" justifyContent="flex-end" pr={1}>
                    <IconButton
                      onClick={() => {
                        setIsCollapsed(!isCollapsed);
                      }}
                    >
                      <MenuOutlinedIcon />
                    </IconButton>
                  </Box>
                </MenuItem>
              )}

              {isCollapsed && (
                <MenuItem style={{ marginBottom: "4px" }}>
                  <Box display="flex" justifyContent="center">
                    <IconButton
                      id="switcher"
                      onClick={() => {
                        setIsCollapsed(!isCollapsed);
                      }}
                    >
                      <MenuOutlinedIcon />
                    </IconButton>
                  </Box>
                </MenuItem>
              )}

              {/* Menu Toggle */}

              {/* Working */}
              {isCollapsed
                ? document
                    .getElementById("mainContent")
                    .classList.add("collapsed")
                : (document
                    .getElementById("mainContent")
                    .classList.remove("collapsed"),
                  document
                    .getElementById("mainContent")
                    .classList.add("content"))}

              {/* Logo For Expanded Sidebar */}
              {!isCollapsed && (
                <Box mb="16px" sx={{ left: "0", right: "0" }}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <img
                      src={Logo}
                      alt="Yes Shop Logo"
                      style={{ maxWidth: "70%", height: "auto" }}
                    />
                  </Box>
                </Box>
              )}
              {/* Logo For Expanded Sidebar */}

              {/* Logo Mark for Collapsed Sidebar */}
              {isCollapsed && (
                <Box display="flex" justifyContent="center" alignItems="center">
                  <SvgIcon sx={{ width: "100%", height: "50px" }}>
                    <svg
                      width="59"
                      height="61"
                      viewBox="0 0 59 61"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M58.4803 10.9012V45.5451C58.4803 46.5912 57.7869 47.5097 56.7817 47.7987L12.323 60.5448C12.2158 60.5761 12.1075 60.6002 11.9979 60.6195L15.5107 48.734C15.7695 47.8577 16.5231 47.2124 17.432 47.0968L49.6429 42.9256C50.3652 42.8341 50.9046 42.2177 50.9046 41.4894V15.6022C50.9046 14.8679 50.3496 14.2527 49.6201 14.1781L12.8418 10.3812C11.9943 10.2945 11.2576 10.9602 11.2576 11.8101V60.6953C10.8964 60.6953 10.5377 60.6448 10.1922 60.5448L1.80027 58.1372C0.799886 57.8495 0.108887 56.9333 0.108887 55.892V7.23437C0.108887 6.31344 0.644592 5.47558 1.48005 5.08794L10.1874 1.04427C10.8844 0.719239 11.6645 0.618118 12.4205 0.75415L56.5457 8.5935C57.6653 8.79213 58.4815 9.76603 58.4815 10.9024L58.4803 10.9012Z"
                        fill="#FF0084"
                      />
                      <path
                        d="M24.7319 22.8728C24.5007 22.7656 24.2564 22.7139 24.018 22.7139C23.38 22.7139 22.7684 23.075 22.4807 23.6938L20.061 28.8811L17.6413 23.6938C17.3536 23.075 16.742 22.7139 16.104 22.7139C15.8632 22.7139 15.6189 22.7644 15.3877 22.8728C14.5402 23.27 14.1743 24.2764 14.5691 25.1263L18.189 32.8911L16.157 37.2501C15.7597 38.0976 16.1281 39.1064 16.9756 39.5037C17.8255 39.8986 18.8343 39.5302 19.2291 38.6827L20.0598 36.9022L21.9305 32.8923L25.5505 25.1276C25.9453 24.2776 25.577 23.2712 24.7295 22.874L24.7319 22.8728Z"
                        fill="#FF0084"
                      />
                      <path
                        d="M36.0411 24.5355C34.8313 23.3172 33.2374 22.7129 31.6459 22.7129C30.0545 22.7129 28.4642 23.3196 27.2507 24.5355C25.894 25.8922 25.2969 27.722 25.457 29.4965C25.5882 30.9808 26.2877 32.3929 27.3795 33.4366C28.469 34.4767 29.9497 35.1473 31.6459 35.1473C33.5829 35.1473 35.0371 34.5815 36.4239 33.3271C36.6563 33.1164 37.2967 32.5362 37.2967 31.7561C37.2967 31.1746 36.9091 30.5342 36.1663 30.3717C35.4524 30.2152 34.735 30.7665 34.2438 31.1915C33.5552 31.7862 32.2334 32.1485 31.2053 32.0065C29.8871 31.8259 28.8229 30.6245 28.8229 29.8107L36.3758 29.8083C37.2377 29.8083 37.9275 29.0426 37.818 28.1879C37.6085 26.5483 36.9356 25.436 36.0411 24.5355V24.5355ZM33.4806 27.2345C31.9938 27.2321 30.7864 27.2297 29.8065 27.2297C29.461 27.2297 29.2587 26.8444 29.4453 26.5543C30.0135 25.69 30.8731 25.2554 31.6459 25.2554C32.4188 25.2554 33.2759 25.6888 33.8465 26.5567C34.0367 26.8468 33.8297 27.2345 33.4806 27.2345V27.2345Z"
                        fill="#FF0084"
                      />
                      <path
                        d="M46.0558 28.6755C45.2673 28.2084 44.2019 27.6931 42.9475 27.2345C42.4299 27.0455 41.2778 26.4195 42.0434 25.767C42.2228 25.6141 42.4636 25.5455 42.6995 25.5347C43.3677 25.5022 43.9636 25.7478 44.539 26.0583C45.0025 26.3099 45.5057 26.6687 46.0558 26.6687C46.8082 26.6687 47.3271 26.1029 47.4402 25.5383C47.5353 25.0628 47.368 24.6258 47.1862 24.4079C46.7697 23.9107 45.2083 22.7129 42.9487 22.7129C40.4062 22.7129 38.4283 24.4079 38.4283 26.3858C38.4283 27.7979 39.1121 28.6995 39.8753 29.2172C40.9371 29.9371 42.1012 30.3404 42.9487 30.6233C43.4399 30.787 44.5342 30.9832 44.3753 31.7332C44.2537 32.3098 43.4062 32.3183 42.9487 32.3183C42.2011 32.3183 41.4199 31.8608 40.8083 31.472C40.4977 31.2745 40.2389 31.0229 39.8681 30.9423C39.4685 30.8544 39.0387 30.9411 38.7112 31.1879C38.0082 31.72 37.9721 32.7107 38.5379 33.3066C39.1037 33.9025 40.6229 35.1412 42.9499 35.1412C45.7753 35.1412 47.7532 33.4487 47.7532 31.4708C47.7532 30.3319 47.1272 29.3075 46.0582 28.6743L46.0558 28.6755Z"
                        fill="#FF0084"
                      />
                    </svg>
                  </SvgIcon>
                </Box>
              )}
              {/* Logo Mark for Collapsed Sidebar */}

              {/* <Box pt={2} padding={isCollapsed ? undefined : "0 10% 0 2%"}> */}
              <Box
                sx={{
                  marginTop: "8px",
                }}
                padding={
                  isCollapsed
                    ? undefined
                    : { xl: "0 10% 0 4%", lg: "0 10% 0 5%", md: "0 8% 0 0" }
                }
              >
                {incentiveTitleVisibility ? (
                  <Accordion
                    disableGutters
                    defaultExpanded={true}
                    expanded={isCollapsed ? "true" : expanded === "panel1"}
                    onChange={handleChange("panel1")}
                    sx={{
                      boxShadow: "none",
                      // display: isCollapsed ? "none" : "block"
                    }}
                  >
                    <AccordionSummary
                      sx={{
                        padding: "0",
                        display: isCollapsed ? "none" : "flex",
                      }}
                      expandIcon={
                        expanded === "panel1" ? (
                          <Box
                            sx={{
                              position: "absolute",
                              top: "-8px",
                              left: "10px",
                            }}
                          >
                            <SvgIcon>
                              <svg
                                width="24"
                                height="25"
                                viewBox="0 0 24 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19.92 8.64746L13.4 15.1675C12.63 15.9375 11.37 15.9375 10.6 15.1675L4.07996 8.64746"
                                  stroke="black"
                                  strokeWidth="1.5"
                                  strokeMiterlimit="10"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </SvgIcon>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              position: "absolute",
                              top: "-8px",
                              right: "10px",
                            }}
                          >
                            <SvgIcon>
                              <svg
                                width="24"
                                height="25"
                                viewBox="0 0 24 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19.92 8.64746L13.4 15.1675C12.63 15.9375 11.37 15.9375 10.6 15.1675L4.07996 8.64746"
                                  stroke="black"
                                  strokeWidth="1.5"
                                  strokeMiterlimit="10"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </SvgIcon>
                          </Box>
                        )
                      }
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Item
                        title={"Incentives"}
                        to={FINANCE_DASHBOARD}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="37"
                              viewBox="0 0 36 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.7871 5.11928L23.626 10.7972C24.0132 11.5876 25.0455 12.3457 25.9166 12.4909L31.0622 13.3458C34.3528 13.8942 35.127 16.2815 32.7559 18.6366L28.7555 22.6369C28.078 23.3144 27.707 24.621 27.9167 25.5565L29.062 30.5086C29.9653 34.4283 27.8845 35.9445 24.4164 33.896L19.5934 31.0409C18.7224 30.5247 17.2868 30.5247 16.3996 31.0409L11.5766 33.896C8.12469 35.9445 6.02773 34.4122 6.93103 30.5086L8.0763 25.5565C8.28599 24.621 7.91499 23.3144 7.23751 22.6369L3.23716 18.6366C0.882119 16.2815 1.64025 13.8942 4.93086 13.3458L10.0765 12.4909C10.9314 12.3457 11.9637 11.5876 12.3509 10.7972L15.1898 5.11928C16.7383 2.03837 19.2547 2.03837 20.7871 5.11928Z"
                                stroke="currentcolor"
                                strokeWidth="2.41957"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={incentiveTitleVisibility}
                        // display={ isCollapsed ? "none" : "flex" }
                      />
                    </AccordionSummary>

                    <AccordionDetails sx={{ padding: "0" }}>
                      <Item
                        title={DASHBOARD}
                        to={FINANCE_DASHBOARD}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18 27V22.5"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M15.1049 4.23075L4.70991 12.5558C3.53991 13.4858 2.78991 15.4508 3.04491 16.9208L5.03991 28.8608C5.39991 30.9908 7.43991 32.7157 9.59991 32.7157H26.3999C28.5449 32.7157 30.5999 30.9758 30.9599 28.8608L32.9549 16.9208C33.1949 15.4508 32.4449 13.4858 31.2899 12.5558L20.8949 4.24575C19.2899 2.95575 16.6949 2.95575 15.1049 4.23075Z"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={true}
                        sx={{ fontWeight: "700", m: 1 }}
                      />

                      {/* <Item
                        title={CLUSTERS}
                        to={CLUSTER_LISTING_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="37"
                              viewBox="0 0 36 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="18"
                                cy="18.5"
                                r="4"
                                fill="currentColor"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={Cluster}
                      />

                      <Item
                        title={ROLES}
                        to={ROLES_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="37"
                              viewBox="0 0 36 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="18"
                                cy="18.5"
                                r="4"
                                fill="currentColor"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={Roles}
                      />

                      <Item
                        title={HIERARCHY}
                        to={HIERARCHY_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="37"
                              viewBox="0 0 36 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="18"
                                cy="18.5"
                                r="4"
                                fill="currentColor"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={Hierarchy}
                      />

                      <Item
                        title={MODULES}
                        to={MODULES_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="37"
                              viewBox="0 0 36 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="18"
                                cy="18.5"
                                r="4"
                                fill="currentColor"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={Modules}
                      />

                      <Item
                        title={USERS}
                        to={USERS_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="37"
                              viewBox="0 0 36 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="18"
                                cy="18.5"
                                r="4"
                                fill="currentColor"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={Users}
                      />

                      <Item
                        title={REQUEST}
                        to={REQUEST_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="37"
                              viewBox="0 0 36 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="18"
                                cy="18.5"
                                r="4"
                                fill="currentColor"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={Request}
                      />

                      <Item
                        title={ROLE_LOG}
                        to={LOG_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="37"
                              viewBox="0 0 36 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="18"
                                cy="18.5"
                                r="4"
                                fill="currentColor"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={Log}
                      /> */}

                      <Item
                        title={PAYOUT}
                        to={PAYOUT_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="37"
                              viewBox="0 0 36 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M32.9993 18.6953C32.9993 26.9753 26.2793 33.6953 17.9993 33.6953C9.71927 33.6953 2.99927 26.9753 2.99927 18.6953C2.99927 10.4153 9.71927 3.69531 17.9993 3.69531C26.2793 3.69531 32.9993 10.4153 32.9993 18.6953Z"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M23.5663 23.4659L18.9163 20.6909C18.1063 20.2109 17.4463 19.0559 17.4463 18.1109V11.9609"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={Payout}
                      />

                      <Item
                        title={ON_HOLD}
                        to={ON_HOLD_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15.975 28.665V7.335C15.975 5.31 15.12 4.5 12.96 4.5H7.515C5.355 4.5 4.5 5.31 4.5 7.335V28.665C4.5 30.69 5.355 31.5 7.515 31.5H12.96C15.12 31.5 15.975 30.69 15.975 28.665Z"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M31.4987 28.665V7.335C31.4987 5.31 30.6437 4.5 28.4837 4.5H23.0387C20.8937 4.5 20.0237 5.31 20.0237 7.335V28.665C20.0237 30.69 20.8787 31.5 23.0387 31.5H28.4837C30.6437 31.5 31.4987 30.69 31.4987 28.665Z"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={OnHold}
                      />

                      <Item
                        title={EXCLUSION}
                        to={EXCLUSION_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="37"
                              viewBox="0 0 36 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18 33.3047C26.28 33.3047 33 26.5847 33 18.3047C33 10.0247 26.28 3.30469 18 3.30469C9.72 3.30469 3 10.0247 3 18.3047C3 26.5847 9.72 33.3047 18 33.3047Z"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M28.35 7.80469L7.34998 28.8047"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={Exclusions}
                      />

                      <Item
                        title={PAYOUT_DATES}
                        to={PAYOUT_DATES_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="37"
                              viewBox="0 0 36 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 3.60938V8.10938"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M24 3.60938V8.10938"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M5.25 14.2441H30.75"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M31.5 13.3594V26.1094C31.5 30.6094 29.25 33.6094 24 33.6094H12C6.75 33.6094 4.5 30.6094 4.5 26.1094V13.3594C4.5 8.85938 6.75 5.85938 12 5.85938H24C29.25 5.85938 31.5 8.85938 31.5 13.3594Z"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M23.5421 21.1592H23.5555"
                                stroke="currentcolor"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M23.5421 25.6592H23.5555"
                                stroke="currentcolor"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M17.9932 21.1592H18.0067"
                                stroke="currentcolor"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M17.9932 25.6592H18.0067"
                                stroke="currentcolor"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12.4415 21.1592H12.4549"
                                stroke="currentcolor"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12.4415 25.6592H12.4549"
                                stroke="currentcolor"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={PayoutDates}
                      />

                      <Item
                        title={WITHOLDING_TAX}
                        to={WITHOLDING_TAX_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M33 9V12.63C33 15 31.5 16.5 29.13 16.5H24V6.015C24 4.35 25.365 3 27.03 3C28.665 3.015 30.165 3.675 31.245 4.755C32.325 5.85 33 7.35 33 9Z"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M3 10.5V31.5C3 32.745 4.41 33.45 5.4 32.7L7.965 30.78C8.565 30.33 9.405 30.39 9.945 30.93L12.435 33.435C13.02 34.02 13.98 34.02 14.565 33.435L17.085 30.915C17.61 30.39 18.45 30.33 19.035 30.78L21.6 32.7C22.59 33.435 24 32.73 24 31.5V6C24 4.35 25.35 3 27 3H10.5H9C4.5 3 3 5.685 3 9V10.5Z"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M9.375 15H17.625"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={WithholdingTax}
                      />
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  ""
                )}

                <Item
                  title={REPORTS}
                  to={REPORTS_FILTER_ROUTE}
                  icon={
                    <SvgIcon>
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 36 36"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M19.515 4.38047L28.365 8.31047C30.915 9.43547 30.915 11.2955 28.365 12.4205L19.515 16.3505C18.51 16.8005 16.86 16.8005 15.855 16.3505L7.00503 12.4205C4.45503 11.2955 4.45503 9.43547 7.00503 8.31047L15.855 4.38047C16.86 3.93047 18.51 3.93047 19.515 4.38047Z"
                          stroke="currentcolor"
                          strokeWidth="2.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M4.5 16.5C4.5 17.76 5.445 19.215 6.6 19.725L16.785 24.255C17.565 24.6 18.45 24.6 19.215 24.255L29.4 19.725C30.555 19.215 31.5 17.76 31.5 16.5"
                          stroke="currentcolor"
                          strokeWidth="2.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M4.5 24C4.5 25.395 5.325 26.655 6.6 27.225L16.785 31.755C17.565 32.1 18.45 32.1 19.215 31.755L29.4 27.225C30.675 26.655 31.5 25.395 31.5 24"
                          stroke="currentcolor"
                          strokeWidth="2.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </SvgIcon>
                  }
                  selected={selected}
                  setSelected={setSelected}
                  visible={reports}
                />

                {adjustmentTitleVisibility ? (
                  <Accordion
                    disableGutters
                    expanded={isCollapsed ? "true" : expanded === "panel2"}
                    onChange={handleChange("panel2")}
                    sx={{ boxShadow: "none", "&::before": { display: "none" } }}
                  >
                    <AccordionSummary
                      sx={{
                        padding: "0",
                        display: isCollapsed ? "none" : "flex",
                      }}
                      expandIcon={
                        expanded === "panel2" ? (
                          <Box
                            sx={{
                              position: "absolute",
                              top: "-8px",
                              left: "10px",
                            }}
                          >
                            <SvgIcon>
                              <svg
                                width="24"
                                height="25"
                                viewBox="0 0 24 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19.92 8.64746L13.4 15.1675C12.63 15.9375 11.37 15.9375 10.6 15.1675L4.07996 8.64746"
                                  stroke="black"
                                  strokeWidth="1.5"
                                  strokeMiterlimit="10"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </SvgIcon>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              position: "absolute",
                              top: "-8px",
                              right: "10px",
                            }}
                          >
                            <SvgIcon>
                              <svg
                                width="24"
                                height="25"
                                viewBox="0 0 24 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19.92 8.64746L13.4 15.1675C12.63 15.9375 11.37 15.9375 10.6 15.1675L4.07996 8.64746"
                                  stroke="black"
                                  strokeWidth="1.5"
                                  strokeMiterlimit="10"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </SvgIcon>
                          </Box>
                        )
                      }
                      aria-controls="panel2bh-content"
                      id="panel2bh-header"
                    >
                      <Item
                        title={"Adjustments"}
                        // to={EARMARK_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="28"
                              height="29"
                              viewBox="0 0 28 29"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16.8241 7.27539H25.3174"
                                stroke="currentcolor"
                                strokeWidth="1.75"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M2.68286 7.27637H11.1762"
                                stroke="currentcolor"
                                strokeWidth="1.75"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M16.8241 18.5801H25.3174"
                                stroke="currentcolor"
                                strokeWidth="1.75"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M16.8241 25.6504H25.3174"
                                stroke="currentcolor"
                                strokeWidth="1.75"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M21.1042 11.51V3.02832"
                                stroke="currentcolor"
                                strokeWidth="1.75"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M2.68286 26.3625L11.1762 17.8809"
                                stroke="currentcolor"
                                strokeWidth="1.75"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M11.1762 26.3625L2.68286 17.8809"
                                stroke="currentcolor"
                                strokeWidth="1.75"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={adjustmentTitleVisibility}
                      />
                    </AccordionSummary>

                    <AccordionDetails sx={{ padding: "0" }}>
                      <Item
                        title={EARMARK}
                        to={EARMARK_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="37"
                              viewBox="0 0 36 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18 22.4453C20.0711 22.4453 21.75 20.7664 21.75 18.6953C21.75 16.6242 20.0711 14.9453 18 14.9453C15.9289 14.9453 14.25 16.6242 14.25 18.6953C14.25 20.7664 15.9289 22.4453 18 22.4453Z"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M27.75 14.9453V22.4453"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M7.5 33.6953C10.8137 33.6953 13.5 31.009 13.5 27.6953C13.5 24.3816 10.8137 21.6953 7.5 21.6953C4.18629 21.6953 1.5 24.3816 1.5 27.6953C1.5 31.009 4.18629 33.6953 7.5 33.6953Z"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M7.875 25.8203V27.2153C7.875 27.7403 7.60501 28.2353 7.14001 28.5053L6 29.1953"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M3 23.4953V14.1953C3 8.94531 6 6.69531 10.5 6.69531H25.5C30 6.69531 33 8.94531 33 14.1953V23.1953C33 28.4453 30 30.6953 25.5 30.6953H12.75"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={Earmark}
                      />
                      <Item
                        title={FREEZE_ACCOUNT}
                        to={FREEZE_ACCOUNT_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="37"
                              viewBox="0 0 36 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18 12.8359V4.58594"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M18 31.5859V23.3359"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M15 4.58594H21"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M15 31.5859H21"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M13.4549 15.4609L6.31494 11.3359"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M29.685 24.8359L22.545 20.7109"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M4.81494 13.9302L7.81494 8.74023"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M28.1851 27.4302L31.1851 22.2402"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M23.25 18.0859C23.25 19.0459 22.995 19.9309 22.545 20.7109C21.63 22.2859 19.935 23.3359 18 23.3359C16.065 23.3359 14.37 22.2859 13.455 20.7109C13.005 19.9309 12.75 19.0459 12.75 18.0859C12.75 17.1259 13.005 16.2409 13.455 15.4609C14.37 13.8859 16.065 12.8359 18 12.8359C19.935 12.8359 21.63 13.8859 22.545 15.4609C22.995 16.2409 23.25 17.1259 23.25 18.0859Z"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M29.685 11.3359L22.545 15.4609"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M13.4549 20.7109L6.31494 24.8359"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M31.1851 13.9302L28.1851 8.74023"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M7.81494 27.4302L4.81494 22.2402"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={FreezeAccount}
                      />
                      <Item
                        title={CREDIT_DEBIT}
                        to={CREDIT_DEBIT_ROUTE}
                        icon={
                          <SvgIcon>
                            <svg
                              width="36"
                              height="36"
                              viewBox="0 0 36 36"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18.0074 32.9757C26.2744 32.9757 32.9762 26.274 32.9762 18.0069C32.9762 9.73985 26.2744 3.03809 18.0074 3.03809C9.74034 3.03809 3.03857 9.73985 3.03857 18.0069C3.03857 26.274 9.74034 32.9757 18.0074 32.9757Z"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M9.20581 6.03223L21.4503 18.3067L21.4802 11.4958"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M26.7942 29.9684L14.5497 17.709L14.5198 24.5048"
                                stroke="currentcolor"
                                strokeWidth="2.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </SvgIcon>
                        }
                        selected={selected}
                        setSelected={setSelected}
                        visible={DebitCredit}
                      />
                    </AccordionDetails>
                  </Accordion>
                ) : (
                  ""
                )}
                <Item
                  title={CASHOUT_LIMIT}
                  to={CASHOUT_LIMITS_ROUTE}
                  icon={
                    <SvgIcon>
                      <svg
                        width="36"
                        height="37"
                        viewBox="0 0 36 37"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M34.91 1.84533C34.8534 1.70862 34.7702 1.58034 34.6603 1.46844C34.6552 1.46324 34.65 1.45807 34.6448 1.45296C34.4308 1.24286 34.1375 1.11328 33.814 1.11328H33.8138H27.4884C26.8333 1.11328 26.3023 1.64429 26.3023 2.29933C26.3023 2.95436 26.8333 3.48537 27.4884 3.48537H30.9506L25.0683 9.36764C24.6051 9.83082 24.6051 10.5818 25.0683 11.045C25.5315 11.5081 26.2825 11.5081 26.7456 11.045L32.6279 5.1627V8.62491C32.6279 9.27995 33.1589 9.81096 33.814 9.81096C34.469 9.81096 35 9.27995 35 8.62491V2.29933C35 2.13851 34.968 1.98517 34.91 1.84533ZM3.37209 18.1133C3.37209 10.039 9.92573 3.48537 18 3.48537C18.655 3.48537 19.186 2.95436 19.186 2.29933C19.186 1.64429 18.655 1.11328 18 1.11328C8.61566 1.11328 1 8.72894 1 18.1133C1 27.4976 8.61566 35.1133 18 35.1133C27.3843 35.1133 35 27.4976 35 18.1133C35 17.4582 34.469 16.9272 33.814 16.9272C33.1589 16.9272 32.6279 17.4582 32.6279 18.1133C32.6279 26.1875 26.0743 32.7412 18 32.7412C9.92573 32.7412 3.37209 26.1875 3.37209 18.1133ZM18 9.81199C18.655 9.81199 19.186 10.343 19.186 10.998V11.3779H19.3284C21.4874 11.3779 23.1554 13.1927 23.1554 15.3314C23.1554 15.9865 22.6244 16.5175 21.9693 16.5175C21.3143 16.5175 20.7833 15.9865 20.7833 15.3314C20.7833 14.4023 20.0791 13.75 19.3284 13.75H19.186V17.2616L20.7786 17.8171L20.7856 17.8196L20.7856 17.8196C21.3429 18.018 21.9797 18.3293 22.4554 18.9384C22.9416 19.561 23.1395 20.3376 23.1395 21.23C23.1395 23.1715 21.6369 24.8356 19.6604 24.8356H19.186V25.2306C19.186 25.8856 18.655 26.4166 18 26.4166C17.345 26.4166 16.814 25.8856 16.814 25.2306V24.8356H16.6875C14.5284 24.8356 12.8605 23.0209 12.8605 20.8821C12.8605 20.2271 13.3915 19.6961 14.0465 19.6961C14.7015 19.6961 15.2326 20.2271 15.2326 20.8821C15.2326 21.8113 15.9367 22.4635 16.6875 22.4635H16.814V18.9464L15.2373 18.3964L15.2302 18.3939L15.2302 18.3939C14.6804 18.1982 14.0406 17.8925 13.5624 17.2836C13.0729 16.6602 12.8763 15.8808 12.8763 14.9835C12.8763 13.0631 14.3739 11.3779 16.3553 11.3779H16.814V10.998C16.814 10.343 17.345 9.81199 18 9.81199ZM16.3553 13.75H16.814V16.4341L16.0223 16.158C15.6416 16.0221 15.4992 15.9092 15.428 15.8185C15.368 15.7421 15.2484 15.5411 15.2484 14.9835C15.2484 14.2472 15.8065 13.75 16.3553 13.75ZM19.186 22.4635V19.7739L19.9935 20.0556C20.3668 20.1888 20.5121 20.3041 20.5858 20.3984C20.6491 20.4795 20.7674 20.6834 20.7674 21.23C20.7674 21.9769 20.2142 22.4635 19.6604 22.4635H19.186Z"
                          fill="currentcolor"
                        />
                      </svg>
                    </SvgIcon>
                  }
                  selected={selected}
                  setSelected={setSelected}
                  visible={cashoutVisible}
                />

                <footer>
                  <Typography
                    mb={2}
                    sx={{
                      position: "absolute",
                      bottom: "1%",
                      left: 0,
                      right: 0,
                      textAlign: "center",
                      color: colors.grey[300],
                      fontSize: "0.72rem",
                    }}
                  >
                    {isCollapsed ? (
                      ""
                    ) : (
                      <span>YTLC &copy; All Rights Reserved</span>
                    )}
                  </Typography>
                </footer>
              </Box>
            </Menu>
          </ProSidebar>
        </Box>
      ) : (
        ""
      )}
    </Box>
  );
};

export default Sidebar;
